var _path, _path2, _mask, _path3, _mask2, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudCycleSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86441 12.2019C2.71587 12.1154 1 10.3056 1 8.0856C1 5.81044 2.80224 3.96606 5.02542 3.96606C5.18358 3.96606 5.3396 3.9754 5.49299 3.99356C6.40996 2.21348 8.236 1 10.339 1C12.84 1 14.9493 2.7163 15.6037 5.06079C15.8772 4.99151 16.1632 4.95475 16.4576 4.95475C18.414 4.95475 20 6.5778 20 8.57994C20 10.5821 18.414 12.2051 16.4576 12.2051",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4223 11.6305C14.4223 9.6567 12.83 8.05664 10.8658 8.05664C9.54943 8.05664 8.40008 8.77534 7.78516 9.84356",
    stroke: "currentColor",
    strokeWidth: 1.7
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07889 9.88845L5.41531 12.2466L9.43701 11.552L7.07889 9.88845Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41531 12.2466L4.02619 11.2666L1.66032 14.6202L5.70462 13.9218L5.41531 12.2466ZM7.07889 9.88845L8.05886 8.49933L6.66974 7.51936L5.68977 8.90848L7.07889 9.88845ZM9.43701 11.552L9.72632 13.2272L13.7706 12.5288L10.417 10.1629L9.43701 11.552ZM6.80443 13.2266L8.468 10.8684L5.68977 8.90848L4.02619 11.2666L6.80443 13.2266ZM6.09891 11.2776L8.45704 12.9411L10.417 10.1629L8.05886 8.49933L6.09891 11.2776ZM9.1477 9.87683L5.126 10.5714L5.70462 13.9218L9.72632 13.2272L9.1477 9.87683Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7634 12.8304L16.3487 10.5833L12.5163 11.2452L14.7634 12.8304Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3487 10.5833L17.7378 11.5633L20.1037 8.20964L16.0594 8.9081L16.3487 10.5833ZM14.7634 12.8304L13.7834 14.2195L15.1726 15.1995L16.1525 13.8104L14.7634 12.8304ZM12.5163 11.2452L12.227 9.56995L8.18271 10.2684L11.5363 12.6343L12.5163 11.2452ZM14.9595 9.60332L13.3743 11.8504L16.1525 13.8104L17.7378 11.5633L14.9595 9.60332ZM15.7434 11.4413L13.4963 9.85603L11.5363 12.6343L13.7834 14.2195L15.7434 11.4413ZM12.8056 12.9204L16.638 12.2585L16.0594 8.9081L12.227 9.56995L12.8056 12.9204Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38632 11.1195C7.38632 13.0933 8.9786 14.6934 10.9428 14.6934C12.2592 14.6934 13.4085 13.9747 14.0234 12.9064",
    stroke: "currentColor",
    strokeWidth: 1.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCycleSmall);
export default __webpack_public_path__ + "static/media/CloudCycleSmall.14f2f46f.svg";
export { ForwardRef as ReactComponent };